var render = function render(){var _vm=this,_c=_vm._self._c;return _c('surround-box',{attrs:{"title":_vm.title,"background":"linear-gradient(270deg, rgba(21, 101, 182, 0) 0%, #3B7AC2 50%, rgba(21, 101, 182, 0) 95%)","specialColor":"#0d4257"}},[_c('dv-scroll-board',{staticStyle:{"width":"100%","height":"80%"},attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }